// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3h2ou","empty__icon":"styles_empty__icon__3iCk4","heading":"styles_heading__3YRGZ","content":"styles_content__2X8l7"};